import { UATConstants } from 'src/Common/Models/UATConstants';
import { ITenantUIConfig, TenantProvider } from './interface';
import { USMaasFilterConfig } from './filters/USMaasFilterConfig';
export const USMaaSTenantConfig: Partial<ITenantUIConfig> = {
  nodeName: [UATConstants.PlaceholdersAndTitles.MASSTitle],
  provider: TenantProvider.ARTEMIS,
  TenantExperience: true,
  FeatureConfig: {
    SensitiveInfoValidation: false,
    SensativeInfoErrorCount: false,
    AttachmentConfigurations: [],
    Navigation: {
      GlobalSearch: true,
      Copilot: true,
      Analytics: false,
      RequestAccess: true,
      Settings: true,
      Notifications: true,
      Help: true,
    },
    Hub: {
      Filter: true,
      FilterConfig: USMaasFilterConfig,
      AreaPath: [UATConstants.MaaSAreaPath],
      Title: UATConstants.TenantTitles.USMASS,
      ADOTitle: UATConstants.TenantADOText.USMASS,
      Create: [
        {
          Text: UATConstants.CreateActionMenuTitle.CreateUSMaasRequest,
          Key: UATConstants.CreateActionMenuKey.CreateUSMaasRequest,
          NodeName: '',
        },
      ],
      BulkUpload: false,
      DownloadTemplate: false,
      Download: true,
      Email: true,
      LocalSearch: true,
      ColumnOptions: true,
      ColumnOptionsConfig: [],
      SplitMode: true,
      DisableCreateForm: true,
      BulkEdit: false,
      BulkEditConfig: [],
      CreateRAID: false,
      DownloadTemplateConfig: {
        tenantToolName: 'maas',
        title: UATConstants.PlaceholdersAndTitles.MASSTitle,
        excelColumnSequence: {
          'Title': 1,
          'Action Owner': 2,
          'Assigned Team': 3,
          'MaaS ChildAccount': 4,
          'MaaS Data Capture Date': 5,
          'MaaS Event Contact List Password': 6,
          'MaaS Event Date': 7,
          'MaaS Event Name': 8,
          'MaaS Event Registration URL': 9,
          'MaaS Event Type': 10,
          'MaaS Lead Source Type': 11,
          'MaaS Marketing Play': 12,
          'MaaS Organizational Unit': 13,
          'MaaS SMPP Approval ID': 14,
          'MaaS SpecificOrganizationalTitleForBDM': 15,
          'MaaS_AccountCRMID': 16,
          'MaaS_AccountName': 17,
          'MaaS_AdditionalComments': 18,
          'MaaS_Area': 19,
          'MaaS_CustomerWebURL': 20,
          'MaaS_DocumentCreationDate': 21,
          'MaaS_DocumentLink': 22,
          'MaaS_Industry': 23,
          'MaaS_IsInterestedAccountProfile': 24,
          'MaaS_IsInterestedOrgChat': 25,
          'MaaS_Marketer_Role': 26,
          'MaaS_MCEM_Stage': 27,
          'MaaS_Request_Type': 28,
          'MaaS_Role': 29,
          'MaaS_Segment': 30,
          'MaaS_Seller_Role': 31,
          'MaaS_SpecificCountry': 32,
          'MaaS_SpecificNameForBDM': 33,
          'MaaS_SubSegment': 34,
          'MaaS_TechTargetexistingAccount': 35,
          'MaaS_tpids': 36,
          'MaaS_UpdateExistingAccount': 37,
        },
      },
      RelatedItem: true,
    },
    ManageAction: {
      NewExperience: true,
      MandateFormPickers: [
        { formFieldName: 'assignedto', formFieldLabel: UATConstants.PlaceholdersAndTitles.ActionOwner, apiFieldName: 'assignedto' },
        { formFieldName: 'email', formFieldLabel: UATConstants.PlaceholdersAndTitles.Email, apiFieldName: 'requestorsinfo' },
      ],
      Header: {
        Tags: true,
        Actions: {
          Follow: true,
          Email: true,
          CopyLink: true,
        },
      },
      Tabs: {
        TechnicalFeedback: false,
        RelatedItems: {
          showRelatedTab: true,
          showTFTCreated: false,
        },
        Attachments: true,
        History: true,
      },
      Panes: {
        CopilotInsights: {
          CustomerInsights: true,
          DiscussionInsights: true,
        },
        StatusUpdate: true,
        ClosureStatement: true,
        Discussion: true,
        Tasks: false,
        EmailConversation: false,
      },
    },
    ManageView: {
      showAddViewButton: true,
      showAddFolderButton: true,
      showCommandBar: true,
      showPreviewFeatureMessageBar: false,
      showSelectFields: false,
      defaultViewId: '35a2abd7-9e87-4c83-9e53-7d4bb39f3a5f',
      systemViewsFolderId: '7c398ac1-20d6-4d72-950f-248fdb4f3c6f',
      sharedViewsFolderId: '2502f00e-3aeb-4499-9f39-7781ac49c7c6',
    },
  },
};
